import { render, staticRenderFns } from "./ModalSubir.vue?vue&type=template&id=2edfe038&"
import script from "./ModalSubir.vue?vue&type=script&lang=js&"
export * from "./ModalSubir.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubir.vue?vue&type=style&index=0&id=2edfe038&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports